import React from 'react';

import {
  SearchResult,
} from '../../../components';

import ParagraphsPageFull from './Full';
import ParagraphPageTeaserLarge from './teaser_large';

const Opinion = ({ entity, className, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'teaser_large':
      return (<ParagraphPageTeaserLarge entity={entity} {...props} />);
    case 'full':
    default:
      return (<ParagraphsPageFull entity={entity} {...props} />);
  }
};

export default Opinion;
